export default __webpack_public_path__ + "static/media/신한.78cb2aed.svg";